import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-delete-sub-category-dialog',
    templateUrl: './delete-sub-category-dialog.component.html',
    styleUrls: ['./delete-sub-category-dialog.component.scss'],
    standalone: false
})
export class DeleteSubCategoryDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<DeleteSubCategoryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    closeDialog(): void {
        // Pass the undefined back to the parent component
        this.dialogRef.close();
    }

    deleteCategory(): void {
        // Pass the new node back to the parent component
        this.dialogRef.close({ isDelete: true });
    }
}